const PAGE_NAME_META_SELECTOR = 'meta[name="fiverrmeta:pagename"]';

/**
 * The page name BI expects: the page name the layout template writes to the fiverrmeta:pagename meta tag,
 * which the BI listeners use as page.name.
 */
export const getPageName = (): string | undefined =>
    document.querySelector<HTMLMetaElement>(PAGE_NAME_META_SELECTOR)?.content || undefined;
